const STORAGE_KEY = 'seamless-patient-lang';

export function getStoredLanguage() {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function storeLanguage(language) {
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // localStorage unavailable (private browsing) — language won't persist
  }
}
